import React, {useEffect} from "react";
import {Collapse, Empty, Skeleton, Spin} from "antd";
import {ArrowRightOutlined, FileTextOutlined, TeamOutlined} from "@ant-design/icons";
import {GeneralInfoItem} from "../../../../types/generalInfo";
import {useNavigate} from "react-router-dom";
import {useSupCouncilInformationController} from "../../../../controllers/supCouncilInfo-controller";
import "./style.less";

const {Panel} = Collapse;

const SupCouncilInfoTree = () => {
  const {isLoading, supCouncilInfoList, fetchSupCouncilInfoItemsList} = useSupCouncilInformationController();
  const navigate = useNavigate();

  useEffect(() => {
    fetchSupCouncilInfoItemsList([]);
  }, []);

  const openItemInfoPage = (id: string | undefined) => {
    if (id) {
      navigate(`/oversight-committee/${id}`);
    }
  };

  const groupedByCategory: Record<string, GeneralInfoItem[]> = supCouncilInfoList.reduce((acc, item) => {
    acc[item.category] = acc[item.category] || [];
    acc[item.category].push(item);
    return acc;
  }, {} as Record<string, GeneralInfoItem[]>);

  const categories = Object.entries(groupedByCategory);

  if (isLoading && !supCouncilInfoList.length) {
    return <section className="general-information-section">
      <div className="general-information-intro">
        <Skeleton active title={{width: 280}} paragraph={{rows: 2}}/>
      </div>
      <div className="general-information-loading">
        {Array.from({length: 4}).map((_, index) => <Skeleton active key={index} paragraph={{rows: 1}}/>)}
      </div>
    </section>;
  }

  return <Spin spinning={isLoading}>
    <section className="general-information-section">
      <div className="general-information-intro">
        <div className="general-information-intro__icon"><TeamOutlined/></div>
        <div>
          <div className="general-information-intro__eyebrow">Колегіальний орган</div>
          <h1 className="general-information-intro__title">Спостережна рада</h1>
          <p className="general-information-intro__description">
            Офіційна інформація, документи та матеріали про діяльність спостережної ради.
          </p>
        </div>
      </div>

      {categories.length ? <Collapse
        className="general-information-categories"
        defaultActiveKey={categories.map(([category]) => category)}
        expandIconPosition="right"
      >
        {categories.map(([category, items]) => <Panel
          header={<span className="general-information-category-title">
            <span>{category}</span>
            <span className="general-information-category-count">{items.length}</span>
          </span>}
          key={category}
        >
          <div className="general-information-items">
            {items.map((item) => <article className="general-information-item"
                                          key={item.$id || `${category}-${item.title}`}>
              <button className="general-information-item__main general-information-item__main--plain"
                      type="button" onClick={() => openItemInfoPage(item.$id)}>
                <span className="general-information-item__icon"><FileTextOutlined/></span>
                <span className="general-information-item__content">
                  <span className="general-information-item__type">Матеріал ради</span>
                  <span className="general-information-item__title">{item.title}</span>
                </span>
                <ArrowRightOutlined className="general-information-item__arrow"/>
              </button>
            </article>)}
          </div>
        </Panel>)}
      </Collapse> : <div className="general-information-empty">
        <Empty description="Матеріалів спостережної ради поки немає"/>
      </div>}
    </section>
  </Spin>;
};

export default SupCouncilInfoTree;
